module.exports = __webpack_public_path__ + "assets/77ab781d56bda62a1e4d6a099c5c83e2.png";